// @flow
import { ACTIONS } from './constants';
import loadAllReactions from '../api/loadAllReactions';

export default function loadReactions() {
    return async (dispatch: Function) => {
        const reactions = await loadAllReactions();
        dispatch({
            type: ACTIONS.LOAD_REACTIONS,
            reactions
        });
    };
}
